import { NavLink } from "react-router-dom";

import ProfileIco from "../../Media/profile-icon.svg";
import PostIco from "../../Media/image.png";
import ReelIco from "../../Media/reel-icon.svg";
import StoryIco from "../../Media/story-icon.svg";
import IgtvIco from "../../Media/igtv-icon.svg";


const NavigationMenu = (props) => {
    return (
        <>
            <ul className="selection-menu">
                <li>
                    <NavLink
                        to="/HannanMaxIG/profile"
                        className="nav-buttons"
                        activeClassName="active-navigation"
                    >
                        <img
                            src={ProfileIco}
                            className="nav-icons"
                            alt="search profile"
                        />
                        <p className="nav-name"> Profile </p>
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/HannanMaxIG/story"
                        className="nav-buttons"
                        activeClassName="active-navigation"
                    >
                        <img
                            src={StoryIco}
                            className="nav-icons"
                            alt="search Story"
                        />
                        <p className="nav-name"> Story </p>
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/HannanMaxIG/reel"
                        className="nav-buttons"
                        activeClassName="active-navigation"
                    >
                        <img
                            src={ReelIco}
                            className="nav-icons"
                            alt="search Reel"
                        />
                        <p className="nav-name"> Reel </p>
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/HannanMaxIG/post"
                        className="nav-buttons"
                        activeClassName="active-navigation"
                    >
                        <img
                            src={PostIco}
                            className="nav-icons"
                            alt="search Post"
                        />
                        <p className="nav-name"> Post </p>
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/HannanMaxIG/igtv"
                        className="nav-buttons"
                        activeClassName="active-navigation"
                    >
                        <img
                            src={IgtvIco}
                            className="nav-icons"
                            alt="search Igtv"
                        />
                        <p className="nav-name"> Igtv </p>
                    </NavLink>
                </li>
            </ul>
        </>
    );
};

export default NavigationMenu;
